import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import '../../forms/superAdminForms/style.scss';
import AdminPageLayout from '../../layout/AdminPageLayout';
import Headline from '../../ui/Headline';
import InstitutionForm from '../../forms/superAdminForms/institution';
import EditorForm from '../../forms/superAdminForms/editor';
import { APP_ROUTES } from '../../app.config.vars/routes';
const SuperAdminPageLayout = ({ title, formType, unit, unitIid, institutionId, }) => {
    return (_jsx(AdminPageLayout, { logoutButton: true, logoLink: unit === 'institution'
            ? APP_ROUTES.institutions
            : institutionId
                ? APP_ROUTES.institutions
                : APP_ROUTES.editors, children: _jsxs("div", { className: 'page-content-wrapper super-admin-page', children: [_jsx(Headline, { title: title, type: 'h1' }), unit === 'institution' ? (_jsx(InstitutionForm, { formType: formType, institutionId: unitIid })) : (_jsx(EditorForm, { formType: formType, editorId: unitIid, institutionId: institutionId }))] }) }));
};
export default SuperAdminPageLayout;
